export default __webpack_public_path__ + "static/media/meatslabs.4be1a485.png";